export default "__VITE_ASSET__DTLeNapP__"